export default {
  DEFAULT_SIZE_TEXT: 'Tamaño: 300 x 300px',
  DEFAULT_INSTRUCTION_TEXT: 'Subir imagen (formato .jpg o .png)',
  DEFAULT_ICON_COLOR: 'rgb(0,99,173)',
  DEFAULT_ICON_WIDTH: '20px',
  DEFAULT_ICON_HEIGHT: '20px',
};
